import React, { useState } from "react";
import Refuse from "./refuse";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

function ComplaintDetailsModal({
  selectedReport,
  complaintDescription,
  onActionCompleted,
  complaintStatus,
  adminName,
}) {
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [zoomedImage, setZoomedImage] = useState(null);

  // NEW: lock actions after approve/refuse
  const [actionLocked, setActionLocked] = useState(false);
  const [actionType, setActionType] = useState(null); // "approve" | "refuse"

  const formattedDate = selectedReport?.date
    ? new Date(selectedReport.date).toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  const isPending = complaintStatus === "Pending";

  // APPROVE
  const handleApprove = async () => {
    setLoading(true);
    setActionLocked(true);
    setActionType("approve");

    try {
      const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
      const response = await axios.post(
        `/api/complaints/approve-complaint/${selectedReport.complaintId}`,
        {},
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );

      Swal.fire({
        title: "Sukses!",
        text: response.data?.message || "Ankesa u aprovua me sukses.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#18817d",
      });

      // Close modal
      document.getElementById("my-modal-5").checked = false;

      // Trigger parent refresh
      onActionCompleted?.(selectedReport.complaintId, 1);
    } catch (err) {
      Swal.fire({
        title: "Gabim!",
        text:
          err.response?.data?.message ||
          "Ndodhi një gabim gjatë aprovimit të ankesës.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const combinedMedia = [
    ...(selectedReport?.photos || []),
    ...(selectedReport?.videos || []),
  ];

  const isVideo = (media) => {
    if (!media || typeof media !== "string") return false;
    const lower = media.split("?")[0].toLowerCase();
    return (
      lower.endsWith(".mp4") ||
      lower.endsWith(".avi") ||
      lower.endsWith(".mov")
    );
  };

  const prevSlide = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  const prevZoomed = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  const nextZoomed = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl rounded-2xl bg-white p-6 shadow-xl">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="w-full text-center text-lg font-bold text-brand-500">
              Detajet e raportit dhe ankesës
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm bg-white text-brand-700 hover:text-white"
            >
              ✕
            </label>
          </div>
          <hr />

          <div className="mt-4 space-y-3">
            <p>
              <span className="font-bold">Qyteti:</span>{" "}
              {selectedReport?.address
                ? (() => {
                    const gpsMatch =
                      selectedReport.address.match(/\(([^)]+)\)/);
                    const cityName = selectedReport.address
                      .split("(")[0]
                      .trim();

                    if (gpsMatch && gpsMatch[1]) {
                      const [lat, lng] = gpsMatch[1]
                        .split(",")
                        .map((x) => x.trim());
                      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

                      return (
                        <>
                          <span>{cityName} </span>
                          <span>(</span>
                          <a
                            href={googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer font-semibold text-blue-600 underline"
                          >
                            {lat}, {lng}
                          </a>
                          <span>)</span>
                        </>
                      );
                    }
                    return <span>{selectedReport?.address}</span>;
                  })()
                : "Unknown"}
            </p>

            <p>
              <b>Kategoria:</b> {selectedReport?.category}
            </p>
            <p>
              <b>Data:</b> {formattedDate}
            </p>
            <p style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
              <b>Përshkrimi:</b> {selectedReport?.textContent}
            </p>
            <p>
              <b>Ankesa:</b> {complaintDescription}
            </p>
          </div>

          {combinedMedia.length > 0 && (
            <div className="relative mx-auto mt-6 flex max-w-2xl items-center justify-center">
              <div className="relative">
                {isVideo(combinedMedia[currentIndex]) ? (
                  <video
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full rounded-lg object-contain shadow"
                    controls
                  />
                ) : (
                  <img
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                    alt={`media-${currentIndex + 1}`}
                    onClick={() => setZoomedImage(combinedMedia[currentIndex])}
                  />
                )}

                {adminName?.trim() && (
                  <div className="pointer-events-none absolute inset-0 flex select-none items-center justify-center">
                    <span
                      className="break-words text-center font-bold text-white/30"
                      style={{
                        transform: "rotate(-45deg)",
                        userSelect: "none",
                        width: "90%",
                        fontSize: "clamp(14px, 4vw, 40px)",
                        lineHeight: "1.1",
                      }}
                    >
                      {adminName}
                    </span>
                  </div>
                )}
              </div>

              {combinedMedia.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❮
                  </button>

                  <button
                    onClick={nextSlide}
                    className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          )}

          <footer className="modal-action mt-6 flex justify-end gap-2">
            <label
              htmlFor="my-modal-5"
              className="btn bg-white text-brand-700 hover:text-white"
            >
              Kthehu
            </label>

            {/* BUTTONS NOW DISABLED AFTER PRESS */}
            {isPending && (
              <>
                <button
                  className="btn bg-green-500 text-white hover:bg-green-600 disabled:bg-gray-400"
                  onClick={handleApprove}
                  disabled={loading || actionLocked}
                >
                  {actionLocked && actionType === "approve"
                    ? "Duke aprovuar..."
                    : "Aprovo Ankesen"}
                </button>

                <label
                  htmlFor="my-modal-6"
                  className={`btn bg-red-500 text-white hover:bg-red-600 ${
                    actionLocked ? "btn-disabled bg-gray-400" : ""
                  }`}
                >
                  {actionLocked && actionType === "refuse"
                    ? "Duke refuzuar..."
                    : "Refuzo"}
                </label>

                <Refuse
                  complaintId={selectedReport?.complaintId}
                  onActionCompleted={() => {
                    setActionLocked(true);
                    setActionType("refuse");

                    // Close the refuse modal (modal-6)
                    const modal6 = document.getElementById("my-modal-6");
                    if (modal6) modal6.checked = false;

                    // Close the main modal (modal-5)
                    const modal5 = document.getElementById("my-modal-5");
                    if (modal5) modal5.checked = false;

                    // Notify parent
                    onActionCompleted?.(selectedReport?.complaintId, 2);

                    // Reset loading UI state after finishing
                    setTimeout(() => {
                      setActionLocked(false);
                      setActionType(null);
                    }, 300);
                  }}
                />
              </>
            )}
          </footer>
        </div>
      </div>

      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>

          {combinedMedia.length > 1 && (
            <>
              <button
                onClick={prevZoomed}
                className="absolute left-5 text-4xl text-white"
              >
                ❮
              </button>
              <button
                onClick={nextZoomed}
                className="absolute right-5 text-4xl text-white"
              >
                ❯
              </button>
            </>
          )}

          <div className="relative">
            <img
              src={zoomedImage}
              className="max-h-full max-w-full rounded-lg object-contain transition-transform duration-200 hover:scale-110"
              alt="Zoomed Media"
            />
            {adminName?.trim() && (
              <div className="pointer-events-none absolute inset-0 flex select-none items-center justify-center">
                <span
                  className="break-words text-center font-bold text-white/30"
                  style={{
                    transform: "rotate(-45deg)",
                    userSelect: "none",
                    width: "90%",
                    fontSize: "clamp(14px, 4vw, 40px)",
                    lineHeight: "1.1",
                  }}
                >
                  {adminName}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ComplaintDetailsModal;
